import { type ReactNode } from 'react'

interface PortalPageHeaderProps {
  title: string
  description?: string
  action?: ReactNode
}

/** Consistent page header for every Portal screen: one h1, one-line description, optional action slot. */
export function PortalPageHeader({ title, description, action }: PortalPageHeaderProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between mb-6">
      <div className="min-w-0">
        <h1 className="text-xl sm:text-2xl font-semibold text-foreground tracking-tight">{title}</h1>
        {description && (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  )
}
